import api, {
  globalErrorHandler
} from "../Api"

export const GET_REIMBURSEMENT_LIST_BY_USER = "GET_REIMBURSEMENT_LIST_BY_USER";
export const GET_LATEST_PA = "GET_LATEST_PA";
export const SAVE_REIMBURSEMENT = "SAVE_REIMBURSEMENT";
export const RE_LOADING = "RE_LOADING";
export const GET_INFORMATION_LISTS = "GET_INFORMATION_LISTS";
export const GET_STUDIES_CATEGORY = "GET_STUDIES_CATEGORY";
export const CLEAN_SAVEREIMBURSEMENT = "CLEAN_SAVEREIMBURSEMENT";
export const GET_VALIDATION = "GET_VALIDATION";
export const GET_CAREERS = "GET_CAREERS";
export const RE_LOADING_CAREERS = "RE_LOADING_CAREERS";
export const RE_LOADING_VALIDATION = "RE_LOADING_VALIDATION";
export const ALLOW_NEW_REQUEST = "ALLOW_NEW_REQUEST";
export const ALLOW_REQUEST_TYPE = "ALLOW_REQUEST_TYPE";

export const GetReimbursementListByUser = (successFactorId) => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING
    });
    await api.get(`/EducationalReimbursement?successFactorId=${successFactorId}`).then((res => {
      dispatch({
        type: GET_REIMBURSEMENT_LIST_BY_USER,
        data: res.data
      });
      //console.log(res.data)
    })).catch(globalErrorHandler);
  }
};

export const GetLatestPA = (successFactorId) => {
  return async dispatch => {
    await api.get(`/EducationalReimbursement/GetLatestPA/${successFactorId}`).then((res => {
      dispatch({
        type: GET_LATEST_PA,
        data: res.data
      });
      //console.log(res.data)
    })).catch(globalErrorHandler);
  }
};

export const SaveReimbursement = (Data, Files, successFactorId, fullname) => {
  var formData = new FormData();
  
  // For SYKES academy studies, use the appropriate values
  if (Data.reimbursementType === "Estudios en Foundever Tech Academy") {
    formData.append('studiesCategory', Data.reimbursementType);
  } else {
    formData.append('studiesCategory', Data.studiesCategory);
  }
  
  // Handle course field consistently across all types
  if (Data.course === "Otro") {
    formData.append('course', Data.courseOther);
  } else {
    formData.append('course', Data.course);
  }
  
  // Add language level for language courses if present
  if (Data.languageLevel && Data.studiesCategory && 
      Data.studiesCategory.toUpperCase() === "IDIOMAS") {
    formData.append('languageLevel', Data.languageLevel);
  }

  formData.append('invoiceNumber', Data.invoiceNumber);
  formData.append('isLastPeriod', Data.isLastPeriod);
  formData.append('techincalStudiesCenter', Data.techStudiesCenterOther !== "" ? Data.techStudiesCenterOther : Data.techStudiesCenter);
  formData.append('languajeCenter', Data.languajeCenterOther !== "" ? Data.languajeCenterOther : Data.languajeCenter);
  formData.append('universityInstitute', Data.universityInstituteOther !== "" ? Data.universityInstituteOther : Data.universityInstitute);
  formData.append('certification', Data.certificationOther !== "" ? Data.certificationOther : Data.certification);
  
  // Handle career field with "Otro" option
  formData.append('carrers', Data.career === "Otro" ? Data.careerOther : Data.career);
  
  formData.append('others', Data.others);
  formData.append('email', Data.email);
  formData.append('reimbursementType', Data.reimbursementType);
  formData.append('comments', Data.comments);
  formData.append('score', Data.score);
  
  if(Data.endDate)
    formData.append('endDate', Data.endDate.toJSON());
  
  if(Data.certificationDate)
    formData.append('certificationDate', Data.certificationDate.toJSON());
  
  if(Files.length > 0){
    Files.forEach(item => {
      formData.append('files', item.file);
    });
  }

  const config = {
    // headers: {
    //     'content-type': 'multipart/form-data',
    // }
  };

  console.log("formData", formData);

  return async dispatch => {
    dispatch({
      type: CLEAN_SAVEREIMBURSEMENT
    });
    dispatch({
      type: RE_LOADING
    });
    await api.post(`/EducationalReimbursement?successFactorId=${successFactorId}&fullname=${encodeURIComponent(fullname)}`, formData, config).then((res => {
      dispatch({
        type: SAVE_REIMBURSEMENT,
        data: res.data,
      });
      //console.log(res.data)
    })).catch(globalErrorHandler);
  };
};

export const GetInformationLists = () => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING
    });
    await api.get(`/EducationalReimbursement/GetInformationLists`).then((res => {
      dispatch({
        type: GET_INFORMATION_LISTS,
        data: res.data
      });
    })).catch(globalErrorHandler);
  };
};

export const GetCarrers = () => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING_CAREERS
    });
    await api.get(`/EducationalReimbursement/GetCarrers`).then((res => {
      dispatch({
        type: GET_CAREERS,
        data: res.data
      });
    })).catch(globalErrorHandler);
  };
};

export const GetValidation = (invoiceNumber) => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING_VALIDATION
    });
    await api.get(`/EducationalReimbursement/IsDuplicateInvoce/${invoiceNumber}`).then((res => {
      dispatch({
        type: GET_VALIDATION,
        data: res.data
      });
    })).catch(globalErrorHandler);
  };
};

export const getStudiesCatergory = () => {
  return async dispatch => {
    await api.get(`/EducationalReimbursement/GetStudiesCategory`).then((res => {
      dispatch({
        type: GET_STUDIES_CATEGORY,
        data: res.data
      });
    })).catch(globalErrorHandler);
  };
};

export const AllowNewRequest = (successFactorId) => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING
    });
    await api.get(`/EducationalReimbursement/AllowNewRequest?successFactorId=${successFactorId}`).then((res => {
      dispatch({
        type: ALLOW_NEW_REQUEST,
        data: res.data
      });
    })).catch(globalErrorHandler);
  };
};

export const AllowRequestType = (successFactorId, requesttype) => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING
    });
    try {
      const response = await api.get(`/EducationalReimbursement/AllowRequestType/${requesttype}?successFactorId=${successFactorId}`);
      dispatch({
        type: ALLOW_REQUEST_TYPE,
        data: response.data
      });
      return response.data;
    } catch (error) {
      globalErrorHandler(error);
      return { error: true };
    }
  };
};